import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function removeWorkerFailure(draft: Draft<IInterventionData>) {
  draft.removeWorker.config.isLoading = false;
}

export default removeWorkerFailure;
